import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyD2igbGpqL8H7icWrLZUtgnX1wzSKtcwZg",
  authDomain: "chilll-9f37b.firebaseapp.com",
  projectId: "chilll-9f37b",
  storageBucket: "chilll-9f37b.appspot.com",
  messagingSenderId: "29740889926",
  appId: "1:29740889926:web:2517c8b9a3b17bba5f1747",
  measurementId: "G-D02PCGKGND",
};

initializeApp(firebaseConfig);
var messaging ;
if ('serviceWorker' in navigator) {
  window.addEventListener('load', function () {
    navigator.serviceWorker.register('./service-worker.js')
      .then(registration => {
      messaging  = getMessaging();
      })
      .catch(err => {
      });
  });
}




export  async  function requestForToken ()  {
  
    getToken(messaging, {vapidKey: 'BMAPKGxIqj8wK6hGDtKSeqCwwpVx1S2e4jlo8WKeJOWZN65sNVcqBKFcGSPZOnJmtzQqFrTJypm-7Qr5i0GM4iw'}).then((currentToken) => {
      if (currentToken) {
        localStorage.setItem("fcm_token", currentToken);
        // Track the token -> client mapping, by sending to backend server
        // show on the UI that permission is secured
      } else {
        // shows on the UI that permission is required 
      }
    }).catch((err) => {
      // catch error while creating client token
    });
};

export const setMessageListener = () =>
  new Promise((resolve) => {
    onMessage(
      messaging,
      (payload) => {
        resolve(payload);
      },
      () => {}
    );
  });
